
import Card from '../../../components/base/Card';

export default function TestimonialsSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            客戶見證
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            聽聽我們的客戶怎麼說，他們的真實體驗是我們最好的證明
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* 客戶見證內容將在此顯示 */}
        </div>
      </div>
    </section>
  );
}
